'use strict';

var EventEmitter = require('events').EventEmitter,
    merge = require('react/lib/merge'),
    shallowEqual = require('react/lib/shallowEqual'),
    bindAll = require('./bindAll'),
    CHANGE_EVENT = 'change';

function createStore(spec) {
  var store = merge(EventEmitter.prototype, merge(spec, {
    emitChange:function() {
      this.emit(CHANGE_EVENT);
    },

    addChangeListener:function(callback) {
      this.on(CHANGE_EVENT, callback);
    },

    removeChangeListener:function(callback) {
      this.removeListener(CHANGE_EVENT, callback);
    }
  }));

  store.setMaxListeners(0);
  bindAll(store);

  return store;
}

module.exports = createStore;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/utils/createStore.js
 ** module id = 157
 ** module chunks = 0
 **/